import { FilterConfig } from './filterconfig.model';
import { Deal } from './deal.model';

/**
 * The structure of the DealsData object
 */
export class DealsData {
  filters: FilterConfig[] = [];
  results: Deal[] = [];
}
